import { useState } from 'react';
import IconButton from 'lib/IconButton';
import DownloadIcon from 'assets/icons/download.svg';
import { ListOfFilesBaseProps } from '../ListOfFiles.types';
import { FileRowContainer } from '../shared/FileRowContainer';
import { renderFilename } from '../shared/renderFilename';

const FlatFilesList = ({
  uploadedFiles,
  renderHeaderComponent,
  onDownloadFile,
}: ListOfFilesBaseProps): React.ReactElement => {
  const [onHoverCategory, setOnHoverCategory] = useState<string>('');

  const renderDownloadButton = (fileId: string): React.ReactElement => {
    return <IconButton icon={DownloadIcon} name="Download" handleOnClick={() => onDownloadFile?.(fileId)} />;
  };

  return (
    <>
      {uploadedFiles.map((item, index) => {
        if (!item?.fileContents?.length) return null;
        return (
          <FileRowContainer
            key={`uploaded-file-container-${item.name}`}
            fileName={item.name}
            onMouseEnter={() => setOnHoverCategory(item.name)}
            onMouseLeave={() => setOnHoverCategory('')}
          >
            <div className="flex items-center h-[30px]">
              {renderFilename(item.name, false)}
              {item?.dynamoDbFileId && renderDownloadButton(item?.dynamoDbFileId ?? '')}
              {renderHeaderComponent?.(item, index, onHoverCategory === item.name)}
            </div>
          </FileRowContainer>
        );
      })}
    </>
  );
};

export default FlatFilesList;
